<div
  class="app-snackbar"
  [class.app-snackbar--no-trailing-control]="!hasTrailingControl"
  [attr.role]="liveRegionRole"
>
  @if (iconName) {
    <mat-icon
      [svgIcon]="iconName"
      class="app-snackbar__icon"
      [ngClass]="iconRoleClass"
      aria-hidden="true"
    ></mat-icon>
  }
  <span class="app-snackbar__text">{{ data.text }}</span>
  @if (showAction) {
    <div class="app-snackbar__action-wrapper">
      <button
        type="button"
        mat-button
        color="primary"
        class="app-snackbar__action"
        (click)="onAction()"
      >
        {{ data.action!.label }}
      </button>
    </div>
  } @else if (showCloseButton) {
    <div class="app-snackbar__action-wrapper">
      <button
        type="button"
        mat-icon-button
        class="app-snackbar__close"
        [ariaLabel]="'Close'"
        (click)="onDismiss()"
      >
        <mat-icon svgIcon="close" aria-hidden="true"></mat-icon>
      </button>
    </div>
  }
</div>
